import type { JSX } from 'react';
import type { Callback } from 'ts/base/Callback';
import type { DropdownItemProps } from 'ts/components/Dropdown';
import { Dropdown } from 'ts/components/Dropdown';
import type { StoredQueryDescriptor } from 'typedefs/StoredQueryDescriptor';

/** Props for IssueQuerySelector. */
type IssueQuerySelectorProps = {
	selectedQuery: string | null;
	issueQueries: StoredQueryDescriptor[];
	onChange: Callback<string | null>;
	fallbackQueryName?: string;
};

/** A dropdown that allows to select between all stored issue queries or use a custom query */
export function IssueQuerySelector({
	selectedQuery,
	issueQueries,
	onChange,
	fallbackQueryName
}: IssueQuerySelectorProps): JSX.Element {
	const dropdownOptions: DropdownItemProps[] = [fallbackQueryName, ...issueQueries.map(issueQuery => issueQuery.name)]
		.filter(value => value !== undefined)
		.map(issueQuery => {
			return {
				text: issueQuery,
				key: issueQuery,
				value: issueQuery
			};
		});
	return (
		<Dropdown
			fluid
			search
			selection
			data-testid="issue-query-selector"
			options={dropdownOptions}
			value={selectedQuery ?? fallbackQueryName}
			onChange={(_, data) => {
				const value = data.value as string;
				onChange(value === fallbackQueryName ? null : value);
			}}
			selectOnNavigation={false}
		/>
	);
}
